<template>
  <div v-if="matriz_resumen_form.length!=0">
    <h1 id="TituloConsulta">Historia clínica del paciente</h1>
    <hr id="Linea" />
    <div id="DivRegresar" v-if="matriz_informacion_formularios.length!=0">
      <button
        @click="consultarResumenFormularios($store.getters.getCedulaPaciente)"
        id="BotonRegresar"
      >
        <img id="Icono" src="../assets/Cerrar.png" />
      </button>
      <h1 id="TituloConsultaFormulario">{{valor_boton}}</h1>
    </div>
    <div v-if="matriz_informacion_formularios.length==0">
      <div id="DivBotonesFormulario" v-for="(formulario,index) in matriz_resumen_form" :key="index">
        <div id="DivBotonFormulario">
          <img :src=" formulario.logo" style="width:10%" />
          <button
            id="BotonFormulario"
            @click="MostrarDetalleFormularios(formulario.nombre)"
          >{{formulario.nombre}}</button>
        </div>
        <div
          v-if="bandera_mostrar_detalle_formularios && formulario.nombre==valor_boton"
          :id="formulario.nombre"
        >
          <div
            id="DivBotonInformaciónEvento"
            v-for="(evento,index1) in formulario.resumen"
            :key="index1"
          >
            <button
              id="BotonInformaciónEvento"
              @click="consultarInformacionFormularios($store.getters.getCedulaPaciente, formulario.nombre)"
            >
              {{matriz_mensaje_a_visual[index][index1][0]}}
              <a
                style="font-weight: bolder;"
              >{{evento.valor}}</a>
              {{formulario.nombre}} {{matriz_mensaje_a_visual[index][index1][1]}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div style="width:100%" class="grid" v-else-if="matriz_informacion_formularios.length!=0">
      <tarjetas-formulario
        style="padding:0%"
        v-for="(formulario_por_tipo, index2) in matriz_informacion_formularios.data"
        :key="index2"
        :formulario_por_tipo="formulario_por_tipo"
      ></tarjetas-formulario>
    </div>
  </div>
</template>
<script>
import { serverBus } from "../main";
// import datePicker from "vue-bootstrap-datetimepicker";
import axios from "../apiService/config/axios.js";
import Modal from "../components/Modal/Modal";
import metodos_comunes from "../js/metodos_comunes";
import Vue from "vue";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import TarjetasFormulario from "../components/Formulario/TarjetasFormulario";
import { consultarFormulariosExistentes } from "../apiService/request/CrudFormulario.js";

Vue.use(VueMaterial);

export default {
  props: {
    cedulaPaciente: String
  },
  data() {
    return {
      matriz_resumen_formularios: [],
      info_paciente: [],
      bandera_mostrar_detalle_formularios: false,
      valor_boton: "",
      matriz_resumen_form: [],
      mensaje_a_visulizar1: "",
      mensaje_a_visulizar2: "",
      matriz_mensaje_a_visualizar: [],
      matriz_mensaje_a_visualizar2: [],
      matriz_mensaje_a_visual: [],
      matriz_informacion_formularios: [],
      matriz_campos_tarjetas: [],
      matriz_tipo_campo: [],
      config: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        locale: "es"
      },
      bandera_ver_informacion_formulario: false,
      nuevo_valor: "",
      mostrar_confirmacion: false,
      modal1: "",
      bandera_ver_mas: false,
      valor_index: "",
      mensaje_modal: "",
      endpointResumenFormularios: "",
      endpointInformacionFormularios: "",
      endpointActualizarFormularios: "",
      opcionesLista: []
    };
  },
  created() {
    this.endpointResumenFormularios =
      "/controlador_datos/historia_clinica/fs/informacion_formularios_resumen";
    this.endpointInformacionFormularios =
      "/controlador_datos/historia_clinica/fs/informacion_formularios_tipo";
    this.endpointActualizarFormularios =
      "/controlador_datos/formularios/api/v1/actualizar_formulario";

    serverBus.$on("formularioActualizadoExitosamente", respuesta => {
      console.log("formularioActualizadoExitosamente", respuesta);
        if(this.valor_boton !=''){
          this.consultarInformacionFormularios(this.$store.getters.getCedulaPaciente,this.valor_boton);
      }
    });
  },
  beforeDestroy() {
    serverBus.$off("refresh_paciente");
    serverBus.$on("cerrarConfirmacion");
    serverBus.$off("formularioActualizadoExitosamente");
  },
  beforeUpdate() {
    console.log("valor_boton", this.valor_boton);
  },
  components: {
    // datePicker,
    Modal,
    TarjetasFormulario
  },
  computed: {
    getReiniciar() {
      this.resetear();
      return this.$store.getters.getReiniciar;
    },
    getResumenHC() {
      if (this.$store.getters.getResumenHC != null) {
        this.consultarResumenFormularios(this.$store.getters.getCedulaPaciente);
        this.$store.dispatch("setResumenHC", null);
      }
      return this.$store.getters.getResumenHC;
    },
    getEspecificoHC() {
      if (this.$store.getters.getNombreFormularioEspecifico != null) {
        // this.bandera_ver_informacion_formulario=true
        this.MostrarDetalleFormularios(
          this.$store.getters.getNombreFormularioEspecifico
        );
        console.log(
          "MostrarDetalleFormularios",
          this.$store.getters.getNombreFormularioEspecifico
        );
      }
      return this.$store.getters.getNombreFormularioEspecifico;
    },
    getFormulariosExistentes() {
      return this.$store.getters.getFormulariosExistentes;
    }
  },
  watch: {
    getReiniciar() {},
    getResumenHC() {},
    getEspecificoHC() {},
    getFormulariosExistentes() {}
  },
  methods: {
    async consultarInformacionFormularios(documento, nombre_formulario) {
      const respuesta = await consultarFormulariosExistentes(
        documento,
        metodos_comunes.reemplazarCaracteresEspeciales(nombre_formulario)
      );
      this.matriz_informacion_formularios = respuesta.data;
      console.log(
        "matriz_informacion_formularios",
        this.matriz_informacion_formularios
      );
      this.filtro_busqueda = [];
      if (this.matriz_informacion_formularios.length > 0) {
        this.filtro_busqueda.push(
          this.matriz_informacion_formularios[0].nombre_formulario
        );
      }
    },
    consultarVariablesLista(lista) {
      console.log("entro_en_fn_de_lista");
      axios
        .get("http://dev.neumobot.com:5005/formularios/api/v1/opciones_lista", {
          params: {
            lista: lista
          }
        })
        .then(Response => {
          this.opcionesLista = Response.data.data;
          console.log("respuesta_fn_de_lista", this.opcionesLista);
        });
    },
    cambiarEstadoModal(estado) {
      this.$store.dispatch("cambiarEstadoModal", estado);
    },
    cambiarIconoModal(src) {
      this.$store.dispatch("cambiarIconoModal", src);
    },
    /**Consuta al endpoint de resumen de formularios
     * @param {*} cedula recibe la cedula del paciente del cual se va a realizar la consulta
     */
    consultarResumenFormularios: function(cedula) {
      this.matriz_resumen_form = [];
      this.matriz_informacion_formularios = [];
      let endpoint;
      let json = {};
      json["cedula"] = cedula;
      // endpoint= this.endpointResumenFormularios
      console.log("consultarResumenFormularios_json", json);
      axios
        .post(
          "/controlador_datos/historia_clinica/fs/informacion_formularios_resumen",
          json
        )
        .then(Response => {
          console.log("repuesta_consultarResumenFormularios", Response);
          this.matriz_resumen_form = Response.data.data;
          this.costruccionFrasesInterfaz();
          console.log(
            "consultarResumenFormularios_matriz",
            this.matriz_resumen_form
          );
        })
        .catch(error => console.log("error", error));
    },

    /**Permite convertir de milisegundos a fecha en formato DD/MM/AAAA
     * @param {*} fecha fecha en millis
     */
    convertirMilisegundosAFecha(fecha) {
      let d = new Date(fecha);
      let semana = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miercoles",
        "Jueves",
        "Viernes",
        "Sabado"
      ];
      let dia_semana = semana[d.getDay()];
      let dia = d.getDate();
      if (dia < 10) {
        dia = "0" + dia;
      }
      let mes = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ];
      let numero_mes = d.getMonth() + 1;
      if (numero_mes < 10) {
        numero_mes = "0" + numero_mes;
      }
      let nombre_mes = mes[d.getMonth()];
      let year = d.getFullYear();
      fecha = dia + "/" + numero_mes + "/" + year;
      return fecha;
    },
    /**Permite reemplazar un string sin caracteres especiales a un string con espacios, el primer caracter en mayusculas y espacios
     * @param {*} nombre string a convertir
     */
    retomarCaracteresEspeciales(nombre) {
      nombre = nombre.toLowerCase();
      nombre = nombre.charAt(0).toUpperCase() + nombre.slice(1);
      nombre = nombre.replace(/[/]/g, "/ ");
      console.log("entroCaracteres", nombre);
      return nombre;
    },
    /**Este metodo se crean las tarjetas de los elementos presentes en los formularios. Cada elemento posee variables que deben recorrerse
     * para mostrar los datos correspondientes( siempre y cuando esas variables sean visibles)
     */
    crearTarjetasNumeroFormularios: function() {
      var i;
      var y = 0;
      let matriz = [];
      this.matriz_tipo_campo = [];
      this.matriz_campos_tarjetas = [];
      for (i = 0; i < this.matriz_informacion_formularios.length; i++) {
        let variables = this.matriz_informacion_formularios[i].variable;
        let count = Object.keys(variables).length;
        console.log("FEcampos", count);
        for (y = 1; y <= count; y++) {
          console.log("ForEachcampos", y);
          let key = "variable" + y;
          console.log("ForEachcamposk", key);
          let nombre_campo;
          let valor_campo;
          let tipo_campo;
          if (variables[key].visible == true) {
            nombre_campo = variables[key].nombre;
            tipo_campo = variables[key].tipo;
            valor_campo = variables[key].valor;
            if (variables[key].nombre == "Nombre" && valor_campo != null) {
              valor_campo = this.retomarCaracteresEspeciales(valor_campo);
            }
            if (
              variables[key].tipo == "fecha" &&
              variables[key].valor != null
            ) {
              valor_campo = this.convertirMilisegundosAFecha(valor_campo);
            }
            matriz.push({ nombre: nombre_campo, valor: valor_campo });
            this.matriz_tipo_campo.push(tipo_campo);
            console.log(
              "camposif",
              nombre_campo,
              valor_campo,
              typeof valor_campo
            );
          }
        }
        this.matriz_campos_tarjetas[i] = matriz;
        matriz = [];
        console.log(
          "matriz_campos_tarjetas",
          this.matriz_campos_tarjetas,
          this.matriz_tipo_campo
        );
      }
    },
    /**Este metodo permite ver el resumen de los formularios cuando se de click sobre uno en especifico
     * @param {*} value valor del boton clickeado. Este es el boton del que se desea ver el resumen
     */
    MostrarDetalleFormularios: function(value) {
      this.$store.dispatch("setNombreFormularioEspecifico", null);
      this.valor_boton = "";
      this.valor_boton = value;
      this.bandera_mostrar_detalle_formularios = !this
        .bandera_mostrar_detalle_formularios;
      console.log(
        "MostrarDetalleFormulariosfn",
        this.valor_boton,
        this.bandera_mostrar_detalle_formularios
      );
    },
    /**Permite convertir de milisegundos a fecha con mes, dia, año y dia de la semana
     * @param {*} fecha fecha en millis
     */
    convertirMilisegundosAFechaCompleta(fecha) {
      let d = new Date(fecha);
      let semana = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miercoles",
        "Jueves",
        "Viernes",
        "Sabado"
      ];
      let dia_semana = semana[d.getDay()];
      let dia = d.getDate();
      let mes = [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic"
      ];
      let nombre_mes = mes[d.getMonth()];
      let year = d.getFullYear();
      fecha = dia + " " + nombre_mes + " " + "de" + " " + year;
      return fecha;
    },
    /**Convierte en formato a.m p.m cualquier hora dada en millis
     * @param {*} hora hora en millis
     */
    convertirMilisegundosAHoraReloj(hora) {
      let d = new Date(hora);
      let formato = "a.m";
      let horas = d.getHours();
      let minutos = d.getMinutes();
      if (horas >= 13) {
        formato = "p.m";
        horas = horas - 12;
      }
      if (minutos == 0) {
        minutos = "0" + "0";
      } else if (minutos >= 1 && minutos <= 9) {
        minutos = "0" + minutos;
      }
      hora = horas + ":" + minutos + " " + formato;
      return hora;
    },
    /** Esta funcion permite construir las frases para mostrar segun el nombre del formulario y el estado.
     *  Estas frases son las que visualiza el usuario cuando da click para ver el resumen.
     */
    costruccionFrasesInterfaz: function() {
      let i;
      let y;
      console.log("costruccionFrasesInterfaz_in");
      for (i = 0; i < this.matriz_resumen_form.length; i++) {
        for (y = 0; y < this.matriz_resumen_form[i].resumen.length; y++) {
          if (this.matriz_resumen_form[i].resumen[y].tipo == "actuales") {
            this.mensaje_a_visulizar1 = "Tiene";
            this.mensaje_a_visulizar2 = "actualmente.";
            this.matriz_mensaje_a_visualizar.push(
              this.mensaje_a_visulizar1,
              this.mensaje_a_visulizar2
            );
          } else if (
            this.matriz_resumen_form[i].resumen[y].tipo == "cerrados"
          ) {
            this.mensaje_a_visulizar1 = "Ha finalizado";
            this.mensaje_a_visulizar2 = ".";
            this.matriz_mensaje_a_visualizar.push(
              this.mensaje_a_visulizar1,
              this.mensaje_a_visulizar2
            );
          }
          if (this.matriz_resumen_form[i].resumen[y].tipo == "Pulmonar") {
            this.mensaje_a_visulizar1 = "Ha tenido";
            this.mensaje_a_visulizar2 = "pulmonar.";
            this.matriz_mensaje_a_visualizar.push(
              this.mensaje_a_visulizar1,
              this.mensaje_a_visulizar2
            );
          } else if (
            this.matriz_resumen_form[i].resumen[y].tipo == "No pulmonar"
          ) {
            this.mensaje_a_visulizar1 = "Ha tenido";
            this.mensaje_a_visulizar2 = "no pulmonares.";
            this.matriz_mensaje_a_visualizar.push(
              this.mensaje_a_visulizar1,
              this.mensaje_a_visulizar2
            );
          }
          this.matriz_mensaje_a_visualizar2.push(
            this.matriz_mensaje_a_visualizar
          );
          this.matriz_mensaje_a_visualizar = [];
        }
        this.matriz_mensaje_a_visual.push(this.matriz_mensaje_a_visualizar2);
        this.matriz_mensaje_a_visualizar2 = [];
      }
      console.log(
        "matriz_mensaje_a_visualizar",
        this.matriz_mensaje_a_visual,
        this.matriz_mensaje_a_visualizar2
      );
    },
    /**Metodo que resetea todas las variables a su valor inicial */
    resetear: function() {
      console.log("resetear_IP");
      (this.matriz_resumen_formularios = []),
        (this.info_paciente = []),
        (this.bandera_mostrar_detalle_formularios = false),
        (this.valor_boton = ""),
        (this.matriz_resumen_form = []),
        (this.mensaje_a_visulizar1 = ""),
        (this.mensaje_a_visulizar2 = ""),
        (this.matriz_mensaje_a_visualizar = []),
        (this.matriz_mensaje_a_visualizar2 = []),
        (this.matriz_mensaje_a_visual = []),
        (this.matriz_informacion_formularios = []),
        (this.matriz_campos_tarjetas = []),
        (this.matriz_tipo_campo = []);
    },
    verMas: function(index) {
      this.valor_index = index;
      this.bandera_ver_mas = !this.bandera_ver_mas;
    }
  }
};
</script>
<style scoped>
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.md-field.md-theme-default.md-has-value .md-input {
  font-family: "Nunito", sans-serif;
  color: #999999;
}
.md-textarea {
  font-family: "Nunito", sans-serif;
  color: #999999;
}

ul li {
  font-family: "Nunito", sans-serif;
  color: #999999;
}

::-webkit-scrollbar {
  width: 1.5%;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  background: #ccc;
}
::-webkit-scrollbar-thumb {
  background: #999;
  border-radius: 10px;
}
#FechaCreacion {
  margin: 1.5% auto 0.5% 10%;
  font-size: 0.8vw;
  font-family: "Nunito", sans-serif;
  color: #999999;
  width: 60%;
  display: flex;
  text-align: center;
  vertical-align: middle;
}
#Linea2 {
  border: 0.5px solid #ccc;
  margin: 2px;
  width: 100%;
  margin: 1% auto 0px auto;
}
.contenedor-modal {
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
}

.contenedor-modal button {
  position: relative;
  top: 40%;
}
#MensajeModal {
  font-size: 1.2vw;
  font-family: "Nunito", sans-serif;
  color: #999999;
  margin-left: 4%;
}

#NombreCampoFormulario {
  font-weight: bolder;
  color: #999999;
  width: 50%;
  margin: 1% 0px 1% 0px;
  text-align: left;
  font-size: 1.05vw;
}
#BotonGuardar {
  border: none;
  background: white;
  font-family: "Nunito", sans-serif;
  font-size: 1.2vw;
  font-weight: bold;
  margin-top: 1%;

  color: #666;
}
#BotonGuardar:hover {
  color: #33ccff;
}
#DivBotonGuardar {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
#BotonRegresar {
  border: none;
  background: white;
  width: 10%;
}
#DivRegresar {
  display: flex;
  justify-content: start;
  width: 100%;
  margin: auto;
  margin-top: 3%;
}

input[type="text"] {
  width: 45%;
  margin-left: 6%;
  font-family: "Nunito", sans-serif;
  font-size: 0.9vw;
  color: rgb(153, 153, 153);

  /* font-size: 1.1vw; */
}
input[type="number"] {
  width: 45%;
  margin-left: 6%;
  font-family: "Nunito", sans-serif;
  font-size: 0.9vw;
  color: rgb(153, 153, 153);
  border: 1px solid #cccccc;
  border-radius: 4px;
}
input[type="date"] {
  width: 45%;
  border: none;
  margin-left: 6%;
  font-family: "Nunito", sans-serif;
  font-size: 0.9vw;
  color: rgb(153, 153, 153);
}
#NombreTarjeta {
  height: 10%;
  width: 100%;
  margin: 0px 0px 0px 0px;
  /*  */
}

textarea {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 2vw;
  margin-left: 4%;
  font-family: "Nunito", sans-serif;
  font-size: 1.1vw;
  color: #666;
  margin: 0px;
  text-align: start;
  font-weight: bold;
  resize: none;
  margin: 0px 0px 0px 2%;
  border: none;
  resize: vertical;
}
.col-md-5 {
  border-right: 2px solid #ccc;
}
#NombreTarjeta ::placeholder {
  font-family: "Nunito", sans-serif;
  font-size: 1.1vw;
  color: #666;
  text-align: start;
  font-weight: bold;
}
::placeholder {
  color: #ccc;
  font-size: 1.1vw;
  font-family: "Nunito", sans-serif;
}

#InformacionTarjeta {
  font-family: "Nunito", sans-serif;
  color: #999;
  margin: 3% 0px 1% 0%;
  display: flex;
  justify-content: space-between;
}
#InformacionTarjeta2 {
  font-family: "Nunito", sans-serif;
  color: #999;
  /* margin: 3% 0px 1% 5%;    */
  display: flex;
  justify-content: space-between;
}
img {
  padding: 1%;
  height: 60%;
}
#BotonInformaciónEvento {
  border: none;
  background: white;
  padding: 0px 2% 0px 2%;
  font-family: "Nunito", sans-serif;
  color: #999;
  margin: auto;
  width: 100%;
  height: 100%;
  text-align: start;
}
#DivBotonInformaciónEvento {
  padding: 2%;
  margin: auto;
  height: 20%;
}
textarea:focus {
  outline: 0;
  /* outline: 1px solid white;
     box-shadow: 0px 1px 1px #ccc */
}
input:focus {
  outline: 0;
}
button:focus {
  outline: 0;
}
#DivBotonesFormulario {
  justify-content: center;
  margin: 5% auto 5% auto;
  width: 70%;
  border: 1.1px solid #cccccc;
  border-radius: 7px;
  padding: 2%;
  box-shadow: -3px 3px 3px #ccc;
}
#DivBotonFormulario {
  padding: 1%;
  margin: auto;
  display: flex;
  justify-content: flex-start;
}
#BotonFormulario {
  width: 80%;
  border: none;
  padding: 2%;
  font-family: "Nunito", sans-serif;
  font-size: 1.5vw;
  font-weight: bold;
  color: #999;
  background: white;
  text-align: start;
}
#Linea {
  border: 0.7px solid #ccc;
  margin: 2px;
  width: 75%;
  margin: 1% auto 0px auto;
}
#TituloConsulta {
  font-family: "Nunito", sans-serif;
  font-size: 1.7vw;
  color: #666;
  font-weight: bold;
  margin: 5% 5% 0px 5%;
  text-align: center;
}
#TituloConsultaFormulario {
  font-family: "Nunito", sans-serif;
  font-size: 1.7vw;
  color: #999;
  margin: 0% 5% 0px 0%;
  text-align: center;
}
#titulo_tarjeta {
  font-family: "Nunito";
  color: #666;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
#tarjeta {
  justify-content: center;
  margin: 3% auto 1% auto;
  width: 75%;
  border: 1.1px solid #ccc;
  border-radius: 7px;
  box-shadow: -1px 3px 2px #ccc;
}
#BotonVerMas {
  border: none;
  background: white;
  font-family: "Nunito", sans-serif;
  color: #999;
  margin-top: 1%;
}
.row {
  justify-content: center;
  margin: 5% auto 0% auto;
  width: 70%;
  border: 1.1px solid #ccc;
  border-radius: 7px;
  padding: 2% 2% 2% 2%;
  box-shadow: -1px 2px 2px #ccc;
}
</style>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/InformacionPaciente.vue